import { cn } from "@/lib/utils";

const classificationStyles: Record<string, string> = {
  image_pull_backoff: "bg-rose-500/10 text-rose-400 border-rose-500/20",
  pod_unschedulable: "bg-amber-500/10 text-amber-400 border-amber-500/20",
  oom_killed: "bg-red-600/10 text-red-400 border-red-600/20",
  vllm_oom: "bg-red-500/10 text-red-400 border-red-500/20",
  crashloopbackoff: "bg-orange-500/10 text-orange-400 border-orange-500/20",
  criu_restore_failed: "bg-purple-500/10 text-purple-400 border-purple-500/20",
  criu_dump_failed: "bg-fuchsia-500/10 text-fuchsia-400 border-fuchsia-500/20",
  mooncake_transfer_failed: "bg-blue-500/10 text-blue-400 border-blue-500/20",
  inference_http_error: "bg-pink-500/10 text-pink-400 border-pink-500/20",
  node_not_ready: "bg-yellow-500/10 text-yellow-400 border-yellow-500/20",
  unknown_timeout: "bg-slate-500/10 text-slate-400 border-slate-500/20",
  unknown: "bg-muted text-muted-foreground border-border",
};

const classificationLabels: Record<string, string> = {
  image_pull_backoff: "image pull",
  pod_unschedulable: "unschedulable",
  oom_killed: "OOMKilled",
  vllm_oom: "vLLM OOM",
  crashloopbackoff: "crash loop",
  criu_restore_failed: "CRIU restore",
  criu_dump_failed: "CRIU dump",
  mooncake_transfer_failed: "mooncake",
  inference_http_error: "inference 5xx",
  node_not_ready: "node not ready",
  unknown_timeout: "timeout",
  unknown: "unknown",
};

export function ClassificationBadge({ classification }: { classification: string }) {
  const label = classificationLabels[classification] ?? classification;
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-md border px-1.5 py-0.5 text-[10px] font-medium uppercase tracking-wide",
        classificationStyles[classification] ?? classificationStyles.unknown,
      )}
    >
      {label}
    </span>
  );
}
